import { Box, Button, Container, Divider, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { matchPath, Outlet, useLocation, useNavigate } from "react-router-dom";
// import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const SettingLayout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
      { text: t("setting.tabs.tabTitle1"), icon: <ArrowRightIcon />, link: "info" },
      { text: t("setting.tabs.tabTitle2"), icon: <ArrowRightIcon />, link: "employee" },
      { text: t("setting.tabs.tabTitle3"), icon: <ArrowRightIcon />, link: "mess-sample" },
      { text: t("setting.tabs.tabTitle4"), icon: <ArrowRightIcon />, link: "coupon-message" },
      { text: t("setting.tabs.tabTitle5"), icon: <ArrowRightIcon />, link: "tag" },
      { text: t("setting.tabs.tabTitle6"), icon: <ArrowRightIcon />, link: "transport" },
      { text: t("setting.tabs.tabTitle7"), icon: <ArrowRightIcon />, link: "warehouse" },
      { text: t("setting.tabs.tabTitle8"), icon: <ArrowRightIcon />, link: "keyword" },
    ];
  

  return <Container maxWidth="xl" className="m-t-40">
      {/* <p>
        <Button
          className="text-transform"
          startIcon={<ArrowBackRoundedIcon />}
          variant="contained"
          color="inherit"
          onClick={() => navigate("/dashboard")}
        >
          {t("common.back")}
        </Button>
      </p> */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={2}>
          <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
            <List disablePadding>
              <Divider />
              {menuItems.map((item, index) => {
                const isActive = !!matchPath(
                  { path: `/dashboard/setting/${item.link}`, exact: true }, 
                  location.pathname
                );

                return (
                  <React.Fragment key={index}>
                    <ListItem disablePadding>
                      <ListItemButton 
                        onClick={() => navigate(item.link)}
                        selected={isActive} // Thuộc tính quan trọng của MUI để hiện trạng thái Active
                        sx={{
                          // Tùy chỉnh màu sắc khi active nếu muốn
                          "&.Mui-selected": {
                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                            borderRight: "4px solid #1976d2",
                            "&:hover": {
                              backgroundColor: "rgba(25, 118, 210, 0.12)",
                            },
                            "& .MuiListItemText-primary": {
                              color: "#1976d2",
                              fontWeight: "bold",
                            },
                            "& .MuiListItemIcon-root": {
                              color: "#1976d2",
                            }
                          }
                        }}
                      >
                        <ListItemIcon sx={{ minWidth: 20 }}>{item.icon}</ListItemIcon>
                        <ListItemText primary={item.text} />
                      </ListItemButton>
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                );
              })}
            </List>
          </Box>
        </Grid>
        <Grid item xs={12} md={10}>
          <Box sx={{ bgcolor: "background.paper" }}>
             <Outlet />
          </Box>
        </Grid>
      </Grid>
    </Container>
};

export default SettingLayout;
